import { render, staticRenderFns } from "./RegistroCuentaBancaria.vue?vue&type=template&id=16177d46&scoped=true&"
import script from "./RegistroCuentaBancaria.vue?vue&type=script&lang=ts&"
export * from "./RegistroCuentaBancaria.vue?vue&type=script&lang=ts&"
import style0 from "./RegistroCuentaBancaria.vue?vue&type=style&index=0&id=16177d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16177d46",
  null
  
)

export default component.exports